/**
 * Canonical registration-related event names from legacy buxusweb (`src/utils/analytics.ts`).
 * Do not rename — Mixpanel reports and funnels depend on these exact strings.
 */
export const RegistrationEventTypes = {
  REGISTRATION_STEP_CHANGED: "registration_step_changed",
  REGISTRATION_FORM_VALIDATION_FAILED: "registration_form_validation_failed",
  REGISTRATION_SUCCESS: "registration_success",
  REGISTRATION_FAILED: "registration_failed",
  REGISTRATION_USER_EXISTS_CHECK: "registration_user_exists_check",
  REGISTRATION_CRM_ACCOUNT_SETUP: "registration_crm_account_setup",
  REGISTRATION_CRM_ACCOUNT_SETUP_FAILED: "registration_crm_account_setup_failed",
  REGISTRATION_QUICK_CODE_FETCHED: "registration_quick_code_fetched",
  REGISTRATION_REFERRER_CONTACT_FETCHED: "registration_referrer_contact_fetched",
  FORM_SUBMITTED: "registration_form_submitted",
  BUTTON_PRESSED: "registration_button_pressed",
  PAGE_VIEWED: "registration_page_viewed",
  ERROR_OCCURRED: "registration_error_occurred",
} as const

export type RegistrationEventName =
  (typeof RegistrationEventTypes)[keyof typeof RegistrationEventTypes]
